module.exports = __webpack_public_path__ + "static/media/22-SBS.b8cd2560.png";